import React, { type ComponentType } from 'react';
import { NavigationJourney } from '@atlassian/jira-navigation-journey/src/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Navigation: ComponentType<Record<any, any>> = () => (
	<>
		<NavigationJourney />
	</>
);

export default Navigation;
